import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: 'app-design-system',
  templateUrl: "./design-system.component.html",
  styleUrls: ["./design-system.component.scss"]
})
export class DesignSystemComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

}
